<template>
  <div>
    <div v-if="config.style_type === 1" class="signboard-type1">
      <img
        class="signboard-type1-bg"
        :src="
          config.property_data.background_image ||
          'https://img.mockuai.com/tms/2018/1/11/upload_d518a3613eeb524246a6baf8aa363e40.png'
        "
      />
      <div class="signboard-type1-main">
        <img
          class="signboard-type1-icon"
          :src="
            config.property_data.head_image ||
            'https://img.mockuai.com/tms/2018/1/11/upload_24b05639d7d0b528ac87b1d07a650597.png'
          "
        />
        <div
          style="padding-left: 100px; font-size: 16px; font-weight: bold"
          class="signboard-type1-name title-text"
        >
          {{ config.property_data.name }}
        </div>
      </div>
    </div>

    <div v-if="config.style_type === 2" class="signboard-type1">
      <img
        class="signboard-type1-bg"
        :src="
          config.property_data.background_image ||
          'https://img.mockuai.com/tms/2018/1/11/upload_d518a3613eeb524246a6baf8aa363e40.png'
        "
      />
      <div class="signboard-type1-main">
        <div
          style="padding-left: 10px; font-size: 16px; font-weight: bold"
          class="signboard-type1-name title-text"
        >
          {{ config.property_data.name }}
        </div>
      </div>
    </div>

    <div
      v-if="config.style_type === 3"
      class="flex-row-center"
      style="padding: 10px; width: 100%; background: #ffffff"
    >
      <img
        style="height: 32px; width: 32px; border-radius: 20px"
        :src="
          config.property_data.head_image ||
          'https://img.mockuai.com/tms/2018/1/11/upload_24b05639d7d0b528ac87b1d07a650597.png'
        "
      />
      <span
        class="title-text text-1-line"
        style="padding: 0 10px; font-size: 14px"
        >{{ config.property_data.name }}</span
      >
    </div>

    <div v-if="config.style_type === 4" class="signboard-type2">
      <img
        class="signboard-type2-bg"
        :src="
          config.property_data.background_image ||
          'https://img.mockuai.com/tms/2018/1/11/upload_6252116e4b37d9cfde291f33bbfb2095.png'
        "
      />
      <div class="signboard-type2-main" style="padding-top: 60px">
        <img
          class="signboard-type2-icon"
          :src="
            config.property_data.head_image ||
            'https://img.mockuai.com/tms/2018/1/11/upload_24b05639d7d0b528ac87b1d07a650597.png'
          "
        />
        <div
          class="signboard-type2-name title-text"
          style="font-size: 16px; font-weight: bold"
        >
          {{ config.property_data.name }}
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "tms-shop-header",
  props: ["config"],

  data() {
    return {};
  },

  components: {},

  mounted() {},

  methods: {},
};
</script>

<style  lang="scss" scoped>
@import "./index.scss";
</style>